export default __webpack_public_path__ + "static/media/menu6.1fe371ca.png";